import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import accounting from 'accounting';
import { PriceContainer } from './styles';

export default class ListingPrice extends PureComponent {
	static propTypes = {
		price: PropTypes.number.isRequired,
		currencySymbol: PropTypes.string,
		cardFrequency: PropTypes.string,
	};

	static defaultProps = {
		currencySymbol: '$',
		cardFrequency: 'box',
	};

	render() {
		const {
			cardFrequency,
			currencySymbol,
			price,
		} = this.props;
		if (!price) return null;
		return (
			<PriceContainer>
				{'From '}
				{accounting.formatMoney(price/100, currencySymbol)}{`/${cardFrequency}`}
			</PriceContainer>
		);
	}
}
